import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        showContent:true, //控制两侧面板是否打开,
        monitorShow:false, // 监控 弹框组件
        monitorUrl:'', // 监控地址
        monitorId:""
    },
    mutations: {
     
    },
    actions: {

    },
    modules: {
        
    }
  })